module.exports = __webpack_public_path__ + "img/hongbao.285f7e89.png";